/* Klaro review buy box — variant picking + sticky bar.
   Add-to-cart itself is handled by the theme's <product-form> element. */
(function () {
  function money(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  function track(action, source, details) {
    var payload = {
      event: 'review_' + action,
      review_action: action,
      article_handle: source ? source.getAttribute('data-kbb-article') : null,
      product_handle: source ? source.getAttribute('data-kbb-product') : null,
      placement: source ? source.getAttribute('data-kbb-placement') : null
    };
    Object.keys(details || {}).forEach(function (key) {
      payload[key] = details[key];
    });
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(payload);
    if (typeof window.gtag === 'function') {
      var analyticsPayload = {};
      Object.keys(payload).forEach(function (key) {
        if (key !== 'event' && key.indexOf('gtm.') !== 0) analyticsPayload[key] = payload[key];
      });
      analyticsPayload.send_to = 'G-JVCNKZCFY7';
      window.gtag('event', payload.event, analyticsPayload);
    }
  }

  function initBox(box) {
    var dataEl = box.querySelector('[data-kbb-variants]');
    if (!dataEl) return;
    var variants = JSON.parse(dataEl.textContent);
    var idInput = box.querySelector('input[name="id"]');
    var priceEl = box.querySelector('.klaro-buybox__price-current');
    var compareEl = box.querySelector('.klaro-buybox__price-compare');
    var atcBtn = box.querySelector('.klaro-buybox__atc');
    var atcPriceWrap = box.querySelector('.klaro-buybox__atc-price');
    var atcAmount = box.querySelector('.klaro-buybox__atc-amount');
    function selectedSize() {
      var on = box.querySelector('.klaro-buybox__size-pill[aria-pressed="true"]');
      return on ? on.getAttribute('data-size') : (variants[0] ? variants[0].size : null);
    }
    function selectedPack() {
      var on = box.querySelector('.klaro-buybox__pack[aria-pressed="true"]');
      return on ? on.getAttribute('data-pack') : null;
    }
    function findVariant(size, pack) {
      for (var i = 0; i < variants.length; i++) {
        if ((variants[i].size === size || size === null) && variants[i].pack === pack)
          return variants[i];
      }
      return null;
    }
    /* Pack cards mirror the PDP: name / price / per-cigar, refreshed per size */
    function refreshPackCards() {
      var size = selectedSize();
      box.querySelectorAll('.klaro-buybox__pack').forEach(function (b) {
        var v = findVariant(size, b.getAttribute('data-pack'));
        b.disabled = !v || !v.available;
        b.classList.toggle('is-unavailable', b.disabled);
        if (!v) return;
        var nameEl = b.querySelector('.klaro-buybox__pack-name');
        var pEl = b.querySelector('.klaro-buybox__pack-price');
        var perEl = b.querySelector('.klaro-buybox__pack-per');
        if (nameEl && v.pack_name) nameEl.textContent = v.pack_name;
        if (pEl) pEl.textContent = money(v.price);
        if (perEl) {
          if (!v.available) perEl.textContent = 'Sold out';
          else if (v.qty > 0) perEl.textContent = money(v.price / v.qty) + ' / cigar';
          else perEl.textContent = '';
        }
      });
    }
    function refreshVitals(v) {
      box.querySelectorAll('[data-kbb-vital]').forEach(function (el) {
        var val = v[el.getAttribute('data-kbb-vital')];
        el.hidden = !val;
        if (val) el.querySelector('.klaro-buybox__vital-value').textContent = val;
      });
    }
    function apply() {
      var v = findVariant(selectedSize(), selectedPack());
      if (!v) return;
      idInput.value = v.id;
      priceEl.textContent = money(v.price);
      if (compareEl) {
        if (v.compare_at && v.compare_at > v.price) {
          compareEl.textContent = money(v.compare_at);
          compareEl.hidden = false;
        } else {
          compareEl.hidden = true;
        }
      }
      atcBtn.disabled = !v.available;
      atcBtn.querySelector('.klaro-buybox__atc-label').textContent = v.available
        ? atcBtn.getAttribute('data-label-add')
        : atcBtn.getAttribute('data-label-soldout');
      if (atcPriceWrap) atcPriceWrap.hidden = !v.available;
      if (atcAmount) atcAmount.textContent = money(v.price);
      refreshVitals(v);
      box.dispatchEvent(new CustomEvent('kbb:variant', { detail: v, bubbles: true }));
    }

    box.querySelectorAll('.klaro-buybox__pack').forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.querySelectorAll('.klaro-buybox__pack').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        apply();
        var v = findVariant(selectedSize(), selectedPack());
        if (v) track('pack_select', box, {
          pack: v.pack,
          size: v.size,
          variant_id: String(v.id),
          value: v.price / 100,
          currency: 'USD'
        });
      });
    });
    box.querySelectorAll('.klaro-buybox__size-pill').forEach(function (btn) {
      btn.addEventListener('click', function () {
        box.querySelectorAll('.klaro-buybox__size-pill').forEach(function (b) {
          b.setAttribute('aria-pressed', b === btn ? 'true' : 'false');
        });
        refreshPackCards();
        var cur = box.querySelector('.klaro-buybox__pack[aria-pressed="true"]');
        if (cur && cur.disabled) {
          var alt = box.querySelector('.klaro-buybox__pack:not([disabled])');
          if (alt) alt.click();
          return;
        }
        apply();
        var v = findVariant(selectedSize(), selectedPack());
        if (v) track('size_select', box, {
          pack: v.pack,
          size: v.size,
          variant_id: String(v.id),
          value: v.price / 100,
          currency: 'USD'
        });
      });
    });

    var form = box.querySelector('form[data-type="add-to-cart-form"]');
    if (form) {
      box.addEventListener('submit', function (event) {
        if (event.target !== form) return;
        event.preventDefault();
        event.stopImmediatePropagation();

        var v = findVariant(selectedSize(), selectedPack());
        if (!v || !v.available || atcBtn.classList.contains('loading')) return;
        var eventDetails = {
          pack: v.pack,
          size: v.size,
          variant_id: String(v.id),
          value: v.price / 100,
          currency: 'USD'
        };
        track('add_to_cart', box, eventDetails);

        var label = atcBtn.querySelector('.klaro-buybox__atc-label');
        var status = box.querySelector('[data-kbb-status]');
        var formData = new FormData(form);
        formData.append('sections', 'cart-icon-bubble');
        formData.append('sections_url', window.location.pathname);
        atcBtn.classList.add('loading');
        atcBtn.disabled = true;
        if (status) status.textContent = 'Adding ' + v.pack_name + ' to your cart.';

        fetch(((window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/') + 'cart/add.js', {
          method: 'POST',
          headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
          body: formData
        }).then(function (response) {
          return response.json().then(function (body) {
            if (!response.ok) throw new Error(body.description || 'Unable to add this item.');
            return body;
          });
        }).then(function (body) {
          var sectionHtml = body.sections && body.sections['cart-icon-bubble'];
          var cartLink = document.getElementById('cart-icon-bubble');
          if (sectionHtml && cartLink) {
            var doc = new DOMParser().parseFromString(sectionHtml, 'text/html');
            var section = doc.getElementById('shopify-section-cart-icon-bubble');
            if (section) cartLink.innerHTML = section.innerHTML;
          }
          var count = cartLink && cartLink.querySelector('.cart-count-bubble [aria-hidden="true"]');
          var dockCart = document.getElementById('kc-dock-cart');
          if (count && dockCart) {
            var itemCount = parseInt(count.textContent.trim(), 10) || 0;
            dockCart.setAttribute('aria-label', 'Cart (' + itemCount + (itemCount === 1 ? ' item)' : ' items)'));
          }
          if (label) label.textContent = 'Added to Cart';
          if (status) status.textContent = v.pack_name + ' added to your cart.';
          track('add_to_cart_success', box, eventDetails);
          document.dispatchEvent(new CustomEvent('klaro:cart-added', { detail: body }));
        }).catch(function (error) {
          if (label) label.textContent = 'Try Again';
          if (status) status.textContent = error.message;
          track('add_to_cart_error', box, Object.assign({ error: error.message }, eventDetails));
        }).finally(function () {
          atcBtn.classList.remove('loading');
          window.setTimeout(function () {
            atcBtn.disabled = !v.available;
            if (label) label.textContent = atcBtn.getAttribute('data-label-add');
          }, 1800);
        });
      }, true);
    }

    box.querySelectorAll('a[href]').forEach(function (link) {
      link.addEventListener('click', function () {
        track('product_click', box, { destination: link.getAttribute('href') });
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            track('buybox_view', box, {});
            observer.disconnect();
          }
        });
      }, { threshold: 0.35 });
      observer.observe(box);
    } else {
      track('buybox_view', box, {});
    }

    refreshPackCards();
    apply();
  }

  /* The bar links to the relevant purchase module or listing. Montecristo uses
     the earlier threshold and mobile treatment defined by the article template. */
  function initSticky(bar) {
    var box = document.getElementById(bar.getAttribute('data-kbb-for'));
    var end = document.getElementById(bar.getAttribute('data-kbb-end') || '');
    if (!box) { bar.remove(); return; }

    var ticking = false;
    function update() {
      ticking = false;
      var vh = window.innerHeight;
      var threshold = bar.getAttribute('data-kbb-early') === 'true'
        ? Math.min(vh * 0.35, 280)
        : vh;
      var engaged = window.scrollY > threshold;
      var r = box.getBoundingClientRect();
      var boxOnScreen = r.bottom > 0 && r.top < vh;
      var atEnd = end ? end.getBoundingClientRect().top < vh : false;
      bar.classList.toggle('is-visible', engaged && !boxOnScreen && !atEnd);
    }
    window.addEventListener('scroll', function () {
      if (!ticking) { ticking = true; requestAnimationFrame(update); }
    }, { passive: true });
    window.addEventListener('resize', update, { passive: true });
    bar.addEventListener('click', function () {
      track('sticky_cta_click', bar, {
        placement: 'sticky',
        pack: bar.getAttribute('data-kbb-pack')
      });
    });
    update();
  }

  function init() {
    document.querySelectorAll('.klaro-buybox').forEach(initBox);
    document.querySelectorAll('.klaro-buybar').forEach(initSticky);
  }
  if (document.readyState === 'loading')
    document.addEventListener('DOMContentLoaded', init);
  else init();
})();
